export const DEVELOPER_CERTIFICATION_STATUS = {
  Pending: 0,
  Certified: 1,
  Released: 2,
  Expired: 3
}

export const DeveloperCertificationStatusString = {
  [DEVELOPER_CERTIFICATION_STATUS.Pending]: "Pending",
  [DEVELOPER_CERTIFICATION_STATUS.Certified]: "Certified",
  [DEVELOPER_CERTIFICATION_STATUS.Released]: "Released",
  [DEVELOPER_CERTIFICATION_STATUS.Expired]: "Expired"
};
